/* Svensk katalog for locale-closing-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'route.arsavslutning-kjop': 'Köp och verifikationer',
  'clo.purchases.title': 'Köp och verifikationer',
  'clo.purchases.year': 'Inkomstår {{year}}',
  'clo.purchases.subtitle': 'Följ upp köp och verifikationer för inkomståret {{year}}.',
  'clo.purchases.pending': '{{count}} köp eller verifikationer måste hanteras innan köpkontrollen för {{year}} är klar.',
  'clo.purchases.ready': 'Inga ohanterade köp eller saknade köpverifikationer hittades för {{year}}.',
  'clo.purchases.unsupported': 'Köpkontrollen stöds inte för det här landet, regelverket eller året.',
  'clo.purchases.purchaseIssues': 'Köp som måste följas upp',
  'clo.purchases.missingTitle': 'Transaktioner som saknar verifikation ({{count}})',
  'clo.purchases.missingSummary': 'Lägg till dokumentationen som hör till varje transaktion.',
  'clo.purchases.reviewMissing': 'Visa och lägg till verifikationer',
  'clo.purchases.documentsModalTitle': 'Saknade verifikationer',
  'clo.purchases.missingHelp': 'Dra en verifikation till rätt rad eller ladda upp den.',
  'clo.purchases.missingDateAction': 'Saknar giltigt datum – öppna transaktionen för att välja år',
  'clo.purchases.upload': 'Ladda upp verifikation',
  'clo.purchases.uploading': 'Laddar upp …',
  'clo.purchases.uploaded': 'Verifikationen har lagts till.',
  'clo.purchases.uploadLater': 'Ladda upp verifikationer senare',
  'clo.purchases.uploadError': 'Kunde inte ladda upp verifikationen.',
  'clo.purchases.noMissingDocumentation': 'Alla transaktioner har verifikation.',
  'clo.purchases.deferredHelp': 'Underlagen laddas upp senare. Du kan fortsätta genomgången, men underlagen måste läggas till innan året avslutas.',
  'clo.purchases.inboxSideHelp': 'Här finns verifikationerna som inte har bokförts ännu.',
  'clo.purchases.inboxInteractionHint': 'Öppna en verifikation för att kontrollera den.',
  'clo.purchases.continueWithoutInbox': 'Fortsätt utan hantering',
  'clo.purchases.continueConfirmTitle': 'Inte relevant för bokslutet?',
  'clo.purchases.continueConfirmText': 'Bekräfta att de {{count}} ohanterade verifikationerna inte är relevanta för köpkontrollen {{year}}. De ligger kvar i inkorgen men blockerar inte det här bokslutet.',
  'clo.purchases.inboxExcluded': 'Verifikationerna har bedömts som inte relevanta för det här bokslutet.',
  'clo.purchases.excludeError': 'Kunde inte spara bedömningen.',
  'clo.purchases.noPurchaseIssues': 'Inga öppna avvikelser på registrerade köp.',
  'clo.purchases.missingDocumentation': 'Saknar verifikation',
  'clo.purchases.lostDocumentation': 'Verifikationen har anmälts som förlorad. Avvikelsen är loggad, men köpet behöver fortfarande dokumentation.',
  'clo.purchases.draft': 'Köputkast måste färdigbehandlas',
  'clo.purchases.undated': 'Saknar giltigt datum. Klargör vilket år posten hör till.',
  'clo.purchases.unknownDate': 'Saknar giltigt datum',
  'clo.purchases.inboxTitle': 'Ohanterade verifikationer ({{count}})',
  'clo.purchases.inboxScope': 'Hantera verifikationerna som hör till {{year}}, eller fortsätt om de inte är relevanta för det här bokslutet.',
  'clo.purchases.scopeHelp': 'En obetald leverantörsfaktura kan vara färdigbokförd. Betalning, momsavstämning och periodisering kontrolleras i separata steg. Klar här betyder att de registrerade köpen och inkorgen har klarat den här kontrollen.',
  'clo.purchases.openPurchase': 'Öppna köpet',
  'clo.purchases.openInbox': 'Hantera verifikationer i inkorgen',
  'clo.purchases.back': 'Tillbaka till köpkontrollen',
  'clo.purchases.backToClosing': 'Tillbaka till bokslut',
  'clo.purchases.loadError': 'Kunde inte öppna köpvyn.',
  'clo.payables.title': 'Leverantörsskulder',
  'clo.payables.itemsTitle': 'Öppna leverantörsposter per 31.12.{{year}}',
  'clo.payables.itemsHelp': 'Leverantörsfakturor som var öppna vid årsskiftet, även från tidigare år. Senare betalningar visas separat och ändrar inte saldot per 31.12.',
  'clo.payables.supplier': 'Leverantör och dokument',
  'clo.payables.date': 'Dokumentdatum och förfallodatum',
  'clo.payables.openAmount': 'Öppet vid årsskiftet',
  'clo.payables.followUp': 'Uppföljning',
  'clo.payables.paidAfterAmount': 'Betalt efter årsskiftet: {{amount}}',
  'clo.payables.balanceTitle': 'Avstämning mot huvudboken',
  'clo.payables.assessmentTitle': 'Bedömning och godkännande',
  'clo.payables.reviewHelp': 'Bedöm posterna med kryssrutorna i tabellen innan du godkänner kontrollen.',
  'clo.payables.saveAssessment': 'Spara bedömning',
  'clo.payables.help': 'Huvudbok och öppna leverantörsposter per 31.12.{{year}} jämförs automatiskt.',
  'clo.payables.ledger': 'Huvudbok',
  'clo.payables.subledger': 'Reskontra',
  'clo.payables.difference': 'Differens',
  'clo.payables.needsReview': 'Måste bedömas ({{count}})',
  'clo.payables.allOpen': 'Alla öppna poster ({{count}})',
  'clo.payables.due': 'Förfaller {{date}}',
  'clo.payables.noDueDate': 'Inget förfallodatum',
  'clo.payables.open': 'Öppna transaktionen',
  'clo.payables.reviewed': 'Bedömd',
  'clo.payables.noRows': 'Inga öppna poster i det här urvalet.',
  'clo.payables.cutOffQuestion': 'Finns det varor eller tjänster som tagits emot före 31.12.{{year}} som ännu inte är bokförda?',
  'clo.payables.cutOffHelp': 'Det här är den del som Plumme inte kan avgöra utifrån bokförda data enbart.',
  'clo.payables.cutOffNo': 'Nej, allt är bokfört',
  'clo.payables.cutOffYes': 'Ja, något saknas',
  'clo.payables.unrecordedHelp': 'Registrera de saknade köpen innan kontrollen kan slutföras.',
  'clo.payables.complete': 'Godkänn kontroll',
  'clo.payables.saved': 'Leverantörsskulderna är kontrollerade.',
  'clo.payables.saveError': 'Kunde inte spara kontrollen.',
  'clo.payables.reason.reconciled': 'Avstämd',
  'clo.payables.reason.notApplicable': 'Inga leverantörsskulder vid årets slut.',
  'clo.payables.reason.unsupported': 'Kontrollen stöds inte för det här landet, regelverket eller året.',
  'clo.payables.reason.stale': 'Sifferunderlaget har ändrats. Kontrollera posterna på nytt.',
  'clo.payables.reason.ledgerDifference': 'Huvudbok och reskontra stämmer inte.',
  'clo.payables.reason.missingDocument': 'En öppen leverantörspost saknar verifikation.',
  'clo.payables.reason.invalidDate': 'En leverantörsfaktura saknar giltigt datum.',
  'clo.payables.reason.basisReviewRequired': 'Kontounderlaget måste kontrolleras.',
  'clo.payables.reason.cutOffRequired': 'En uppgift måste klargöras.',
  'clo.payables.reason.unrecordedItems': 'Saknade köp måste bokföras.',
  'clo.payables.reason.exceptionsRequired': 'Bedöm de markerade posterna.',
  'clo.payables.reason.reviewRequired': 'Kontrollen måste slutföras.',
  'clo.payables.issue.ledgerDifference': 'Differensen måste rättas i bokföringen innan kontrollen kan slutföras.',
  'clo.payables.issue.missingDocument': 'Lägg till verifikationer på öppna poster som saknar dokumentation.',
  'clo.payables.issue.invalidDate': 'Öppna leverantörsfakturan och registrera rätt fakturadatum.',
  'clo.payables.issue.basisReviewRequired': 'Plumme kan inte beräkna ett säkert kontounderlag för den här verksamheten.',
  'clo.payables.flag.old': 'Över 90 dagar gammal',
  'clo.payables.flag.overdue': 'Förfallen över 30 dagar',
  'clo.payables.flag.negative': 'Negativt saldo',
  'clo.payables.flag.duplicate': 'Möjlig dubblett',
  'clo.payables.flag.currency': 'Valutapost',
  'clo.payables.flag.missingDocument': 'Saknar verifikation',
  'clo.payables.flag.paidAfter': 'Betald efter årets slut',
});
